import script from "./BigWin.vue?vue&type=script&setup=true&lang=js"
export * from "./BigWin.vue?vue&type=script&setup=true&lang=js"

import "./BigWin.vue?vue&type=style&index=0&id=2fe5045c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fe5045c"]])

export default __exports__